import { OpenBankingAccount } from '@features/openBanking/types/openBankingAccount'
import { isOpenBankingAccountDeleted } from '@features/openBanking/utils/isOpenBankingAccountDeleted'
import { Account } from '@modules-deprecated/app/accounts/types'

import { BankAccountSource } from '../enums/bankAccountSource'
import { BankAccount } from '../types/bankAccount'

interface IsBankAccountConnectedProps {
  account: Account
  bankAccountsByAccountId: Map<string, BankAccount>
  openBankingAccountsByAccountId: Map<string | null, OpenBankingAccount>
}

export const isBankAccountConnected = ({
  account,
  bankAccountsByAccountId,
  openBankingAccountsByAccountId,
}: IsBankAccountConnectedProps): boolean => {
  const openBankingAccount = openBankingAccountsByAccountId.get(account.id)

  return (
    bankAccountsByAccountId.get(account.id)?.source === BankAccountSource.SHINE_BANKING ||
    (!!openBankingAccount && !isOpenBankingAccountDeleted(openBankingAccount))
  )
}
